import StorefrontIcon from "@mui/icons-material/Storefront";
import LoginIcon from "@mui/icons-material/Login";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import KitchenIcon from "@mui/icons-material/Kitchen";
import EcoIcon from "@mui/icons-material/LocalFlorist";
import LocalDrinkIcon from "@mui/icons-material/LocalDrink";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import GroupWorkIcon from "@mui/icons-material/GroupWork";

const ZoneGroupIcon = ({ groupName, displayName, size = 40, sx = {} }) => {
  const name = String(groupName || displayName || "").toLowerCase();
  const baseSx = { fontSize: size, ...sx };

  if (
    name.includes("entire") ||
    name.includes("store") ||
    name.includes("all")
  ) {
    return <StorefrontIcon sx={{ ...baseSx, color: "#1976d2" }} />;
  }

  if (name.includes("entrance") || name.includes("entry")) {
    return <LoginIcon sx={{ ...baseSx, color: "#388e3c" }} />;
  }

  if (
    name.includes("fridge") ||
    name.includes("freezer") ||
    name.includes("frozen") ||
    name.includes("cold")
  ) {
    return <KitchenIcon sx={{ ...baseSx, color: "#0288d1" }} />;
  }

  if (name.includes("multi")) {
    return <DynamicFeedIcon sx={{ ...baseSx, color: "#0288d1" }} />;
  }

  if (
    name.includes("produce") ||
    name.includes("fruit") ||
    name.includes("vegetable")
  ) {
    return <EcoIcon sx={{ ...baseSx, color: "#689f38" }} />;
  }

  if (
    name.includes("spot") ||
    name.includes("drink") ||
    name.includes("colonial")
  ) {
    return <LocalDrinkIcon sx={{ ...baseSx, color: "#f57c00" }} />;
  }

  if (name.includes("storage") || name.includes("warehouse")) {
    return <InventoryIcon sx={{ ...baseSx, color: "#5d4037" }} />;
  }

  if (
    name.includes("sweet") ||
    name.includes("checkout") ||
    name.includes("self-scan")
  ) {
    return <ShoppingCartIcon sx={{ ...baseSx, color: "#e91e63" }} />;
  }

  return <GroupWorkIcon sx={{ ...baseSx, color: "#757575" }} />;
};

export default ZoneGroupIcon;
